import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { colors } from '../../theme/colors';

const CallToActionSection = ({ onButtonClick }) => {
  return (
    <Box component="section" sx={{ py: { xs: 7, md: 10 } }}>
      <Container maxWidth="lg">
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          sx={{
            borderRadius: 4,
            overflow: 'hidden',
            position: 'relative',
            px: { xs: 3, md: 6 },
            py: { xs: 5, md: 7 },
            backgroundImage:
              'linear-gradient(105deg, rgba(14,28,42,0.88), rgba(31,111,120,0.75)), url(https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=1600&q=70)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            color: '#fff',
          }}
        >
          <Typography
            sx={{
              fontFamily: "'Fraunces', Georgia, serif",
              fontSize: { xs: '1.75rem', md: '2.4rem' },
              fontWeight: 600,
              maxWidth: 520,
              mb: 1.5,
              lineHeight: 1.2,
            }}
          >
            Build a trip that fits you
          </Typography>
          <Typography
            sx={{
              color: 'rgba(255,255,255,0.88)',
              maxWidth: 440,
              mb: 3,
              fontSize: '1.05rem',
            }}
          >
            Customize hotels, transport, and duration — Umrah or holiday — then
            confirm with our team.
          </Typography>
          <Button
            variant="contained"
            endIcon={<ArrowForward />}
            onClick={onButtonClick}
            sx={{
              bgcolor: colors.secondary.main,
              color: '#fff',
              px: 3,
              py: 1.25,
              '&:hover': { bgcolor: colors.secondary.dark },
            }}
          >
            Start custom trip
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default CallToActionSection;
